import * as capSvc from "./services/internalService.js";
import {applyBtnJobDetail} from "../utilities/navigation.js";
let brandId = capSvc.getBrand();
let jobId;
let applyUrl;
window.openApplication = openApplication;
window.hideCaliNotice = hideCaliNotice;
window.acceptGdpr = acceptGdpr;

$(document).ready(() => {
  jobId = window.location.pathname.replace('.html', '').split('/')[
  window.location.pathname.replace('.html', '').split('/').length - 1
    ];
  getJobDetails();

  capSvc.addGdprNotice();
  if (!sessionStorage.getItem('cookiesAccepted') || sessionStorage.getItem('cookiesAccepted') === 'false') {
    $('#gdprNotice').show();
  }
})

function getJobDetails() {

  $.ajax({
    type: "POST",
    url: sessionStorage.getItem('apiHost') + 'internal/job/search/' + jobId,
    success: function (data) {
      applyUrl = data.applyUrl;
      populateDetails(data);
      applyBtnJobDetail()
    },
    beforeSend: function (xhr) {
      xhr.setRequestHeader ('Authorization', 'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
    },
    contentType: 'application/json',
    dataType: 'json'
  });
}
function populateDetails(details) {
  let markup = `
      <div id="headerRow" class="d-flex justify-content-center"">
          <a id="homePage" href="${sessionStorage.getItem('homePageUrl')}">
            <img id="applicationLogoHeader" alt="${sessionStorage.getItem('brandName')} Logo" class="ml-auto w-100" src="${sessionStorage.getItem('logoImageUrl')}" >
          </a>
      </div>
  ${sessionStorage.getItem('headerHtml')}
       <div class="col-12 mb-3" >
              <h1 id="JobTitle" class="h1-responsive">
                  ${details.title}
              </h1>
              <div class="d-flex flex-nowrap flex-row">
                  <label class="bold pr-1">Location:</label>
                  <div id="Location">${details.city}, ${details.stateProvince}</div>
              </div>
              <div class="d-flex flex-nowrap flex-row">
                  <label class="bold pr-1">Job Opening ID:</label>
                  <div id="ReferenceId">
                      ${details.id}
                  </div>
              </div>`
    if (details.salaryLow !== null || details.salaryHigh !== null){
      markup += `<div class="d-flex flex-nowrap flex-row">
                  <label class="bold pr-1">Salary:</label>
                  <div id="Salary">${details.formattedSalary}</div>
              </div>`
    }
    markup +=  `<div class="d-flex flex-nowrap flex-row">
                  <label class="bold pr-1">Date Posted:</label>
                  <div id="DatePosted">
                      ${details.datePosted}
                  </div>
              </div>
              <div class="d-flex flex-nowrap flex-column">
                  <label class="bold pr-1 border-bottom">Description:</label>
                  <div id="DatePosted" class="px-5">
                      ${details.description}
                  </div>
              </div>
        </div>
        <div class="d-flex justify-content-center">
          <button onclick="openApplication('${details.stateProvince}')" class="btn btn-application">
              Apply Now!
          </button>
        </div>
      </div>
<!-- Modal -->
        <div class="modal fade" id="caliNoticeModal" tabindex="-1" aria-labelledby="PRIVACY NOTICE TO CALIFORNIA EMPLOYEES AND JOB APPLICANTS REGARDING THE COLLECTION OF PERSONAL INFORMATION" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">PRIVACY NOTICE TO CALIFORNIA EMPLOYEES AND JOB APPLICANTS REGARDING THE COLLECTION OF PERSONAL INFORMATION</h5>
                <button type="button" class="btn btn-close" data-bs-dismiss="modal" aria-label="Close" onclick="hideCaliNotice()" title="Close">X</button>
              </div>
              <div class="modal-body" style="font-size: 14px">
                ${sessionStorage.getItem('ccpaContent')}
              </div>
              <div class="calNoticeFooter">
                <button type="button" class="btn btn-danger" style="float:left" onclick="hideCaliNotice()" title="Close">Decline</button>
                <button type="button" class="btn btn-application" style="float:right"><a id="caliModalAcceptHref" href="" target="_self" title="Accept">Accept</a></button>
              </div>
            </div>
          </div>
        </div>
`;
  sessionStorage.setItem('jobTitle', details.title)
  document.title = sessionStorage.getItem("jobTitle");
  $('#internalBody').html(markup);
  // removePreloader();
}

function openApplication(stateProvince) {
  let applyTarget = "_self";
  if (applyUrl == null) {
    applyUrl = "../internal/apply.html?jobId=" + jobId
  }
  if (stateProvince === 'CA') {
    capSvc.showCaliNotice(applyUrl)
  } else {
    window.open(applyUrl, applyTarget);
  }
}

function hideCaliNotice() {
  $("#caliNoticeModal").modal("hide");
}

function acceptGdpr() {
  sessionStorage.setItem('cookiesAccepted','true')
  $('#gdprNotice').hide();
}
